export const remoteFilePath = (url) => {
  const base_url = process.env.REACT_APP_SHOW_FILE_BASE_URL

  const full = url.startsWith(base_url) ? url : base_url + url
  const path = url.startsWith(base_url) ? url.substring(base_url.length) : url

  return {
    full,
    path
  }
}